const Title = () => {
  return (
    <span className="title" style={{ margin: 0, fontSize: '24px' }}>
      tweedle
    </span>
  )
}
export default Title
